import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Modal from '../../Components/ComponentModal';
import Button from '../../Components/ComponentButton';
import Select from '../../Components/ComponentSelect';
import T from '../../Utils/Locale';
const SwitchUserModal = ({ users, close }) => {
    const [selectedUser, setSelectedUser] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const userOptions = {};
    users.forEach((user) => {
        userOptions[user.id] = user.fullname;
    });
    const switchUser = () => {
        if (!selectedUser) {
            return;
        }
        setIsLoading(true);
        window.location.href = `/user/switch/${selectedUser}`;
    };
    return (_jsxs(Modal, Object.assign({ closeModal: close }, { children: [_jsx("h4", Object.assign({ className: 'tailwind-reset' }, { children: T('user_menu.switch.title') })), _jsx("p", { children: T('user_menu.switch.description') }), _jsx(Select, { id: 'switch-to-user', title: T('user_menu.switch.choose'), options: userOptions, onChange: (userSelected) => setSelectedUser(userSelected) }), _jsxs(Button, Object.assign({ onClick: switchUser, classes: 'mt-5 tailwind-reset btn bg-dark-teal text-white text-lg py-2 cursor-pointer', isLoading: isLoading }, { children: [_jsx("i", { className: 'fas fa-sign-in-alt' }), _jsx("span", Object.assign({ className: 'pl-2' }, { children: T('user_menu.switch.to') }))] }))] })));
};
export default SwitchUserModal;
